import React, { useState, useEffect, useCallback } from "react";

import {
  Grid,
  InputLabel,
  OutlinedInput,
  Typography,
  ListItemText,
  FormControlLabel,
  Chip,
  Box,
  LinearProgress,
  Tooltip,
  Button,
  Switch,
} from "@mui/material";
import { deepOrange, red } from "@mui/material/colors";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector, useDispatch } from "react-redux";

import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineOppositeContent, {
  timelineOppositeContentClasses,
} from "@mui/lab/TimelineOppositeContent";
import SourceIcon from "@mui/icons-material/Source";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import EventIcon from "@mui/icons-material/Event";
import EventNoteIcon from "@mui/icons-material/EventNote";
import CircleIcon from "@mui/icons-material/Circle";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import DescriptionIcon from "@mui/icons-material/Description";
import { green } from "@mui/material/colors";
// import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
// import CircleIcon from "@mui/icons-material/Circle";

import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import TopButton from "../../Components/UI/TopButtons";
import Placeholder from "../../Components/UI/Placeholder";

import {
  getFormatedDate,
  addDays,
  getDaysDiff,
  getFormatedDateTime,
} from "../../Js/TimeAndDate";
import { joinByKeys, getClassNames } from "../../Js/Common";
import { findIndex, unionBy, flatten, map, find, sortBy } from "lodash";
import { blue } from "@mui/material/colors";
import { getClasswiseProgressReport } from "./Services";
import { getUsersByRoleId } from "../Users/Services";
import { getDefs } from "../SchoolManagement/Services";

import { commonSliceActions } from "../../Store/Slices/CommonSlice";
import moment from "moment";

const daysMixSeries = [
  {
    name: "Ideal Progression",
    field: "defaultDays",
    type: "area",
  },
  {
    name: "Completion Days",
    field: "daysForAttemptAfterFirstLogin",
    type: "line",
  },
  // {
  //   name: "Attempt Days",
  //   field: "daysForAttemptAfterFirstLogin",
  //   type: "line",
  // },
];

const ClasswiseUsage = (props) => {
  // Hooks
  const classes = useStyles();
  const dispatch = useDispatch();

  const successClr = green[500];

  let [selectedDataFilter, setSelectedDataFilter] = useState("default");

  let [allClasses, setAllClasses] = useState([]);
  let [selectedClassId, setSelectedClassId] = useState(null);
  let [assignedClassTrainersNames, setAssignedClassTrainersNames] =
    useState(null);

  let [selectedLearnerId, setSelectedLearnerId] = useState(null);

  let [classwiseData, setClasswiseData] = useState([]);
  let [completion, setCompletion] = useState(0);
  let [classesWithData, setClassesWithData] = useState([]);
  let [completeHere, setCompleteHere] = useState(-1);

  let [allClassStanding, setAllClassStanding] = useState([]);
  let [defaulterFlag, setDefaulterFlag] = useState(true);
  let [academicTermNotConfig, setAcademicTermNotConfig] = useState(false);

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const serverRole = useSelector((state) => state.defs.serverRole);
  const { loader } = useSelector((state) => state.common);

  useEffect(() => {
    let innerFun = async () => {
      if (userInfo) {
        if (userInfo.rolesInfo.title.toLowerCase() == "learner") {
          initialRender();
        } else {
          let allClassesData = await getClassNames(userInfo.site_uuid);
          allClassesData.unshift({ id: "all", value: "Summary" });
          setAllClasses(allClassesData);
          getAndSetWhichClassAssigned();
        }
      }
    };
    innerFun();
  }, [userInfo, selectedDataFilter]);

  const getAndSetWhichClassAssigned = async () => {
    let academicTermData = await getDefs({
      site_uuid: userInfo.site_uuid,
      keyid: "academicTermData",
    });
    let innerData =
      academicTermData.data.data[0]?.keydata[0]?.classWiseCourse[0]?.data;
    if (innerData) {
      let classWhichHaveSomethingAssigned = [];
      innerData.forEach((val, index) => {
        val.classes.forEach((val1, index1) => {
          classWhichHaveSomethingAssigned.push(val1.id);
        });
      });
      setClassesWithData(classWhichHaveSomethingAssigned);
    }
  };

  const initialRender = useCallback(
    async (actor = userInfo.uid) => {},
    [userInfo, selectedDataFilter, selectedLearnerId]
  );

  const handleClassChange = async (itemData) => {
    dispatch(commonSliceActions.setLoader(true));
    setSelectedClassId(itemData.id);
    let arrayOfClasses = [itemData.id];
    if (itemData.id == "all") {
      let temp = [...allClasses];
      temp.shift();
      arrayOfClasses = map(temp, "id");
    }

    let data = await getClasswiseProgressReport({
      site_uuid: userInfo.site_uuid,
      classId: arrayOfClasses,
    });
    console.log("data", data);
    if (data.status == 200) {
      if (itemData.id != "all") {
        let dataToShow = data.data[0]["monthWiseData"];
        let trnrs = data.data[0].assignedClassTrainerName
          .map((tname) => {
            return joinByKeys(tname.name, ["firstname", "lastname"], " ");
          })
          .join(", ");
        setAssignedClassTrainersNames(trnrs);
        let allAssignedSessions = dataToShow.map((val) => {
          return val.assignedSessionArr;
        });
        allAssignedSessions = flatten(allAssignedSessions);
        allAssignedSessions = allAssignedSessions.map((val) => {
          return {
            ...val,
            duration: 0,
            status: false,
          };
        });
        let completedCount = 0;
        let completedSessions = [];
        setCompletion(0);
        dataToShow = dataToShow.map((val, index) => {
          if (val.assignedSessionArr && val.assignedSessionArr.length == 0) {
            setCompleteHere(index);
            console.log("index", index);
          } else {
            setCompleteHere(-1);
          }
          if (val.teachData) {
            val.teachData.forEach((innerVal) => {
              let pos = findIndex(allAssignedSessions, {
                name: innerVal.topicName.trim(),
              });
              if (pos > -1) {
                allAssignedSessions[pos]["duration"] =
                  +allAssignedSessions[pos]["duration"] +
                  +innerVal.totalDuration;
                allAssignedSessions[pos]["status"] =
                  +allAssignedSessions[pos]["duration"] / 1000 >
                  +process.env.REACT_APP_MIN_SEC_TO_COMPLETE
                    ? true
                    : false;

                if (
                  completedSessions.indexOf(
                    allAssignedSessions[pos]["name"].trim()
                  ) == -1
                ) {
                  completedCount = allAssignedSessions[pos]["status"]
                    ? completedCount + 1
                    : completedCount;
                  if (allAssignedSessions[pos]["status"]) {
                    completedSessions.push(
                      allAssignedSessions[pos]["name"].trim()
                    );
                  }
                }
              }
            });
            return {
              ...val,
              teachData: sortBy(
                combineData(val.teachData, val.assignedSessionArr)
                  .filter(
                    (val1) =>
                      findIndex(allAssignedSessions, { name: val1.topicName }) >
                      -1
                  )
                  .map((val2, index2) => {
                    return {
                      ...val2,
                      status: completeOrNot(
                        val2.totalDuration,
                        val.assignedSessionArr,
                        val2.topicName,
                        val.monthStartDate
                      ),
                    };
                  }),
                "topicName"
              ),
            };
          } else {
            return {
              ...val,
              teachData: [],
            };
          }
        });
        setCompletion(
          Math.round(+(+completedCount / +allAssignedSessions.length) * 100)
        );

        console.log("dataToShow", dataToShow);
        setClasswiseData(dataToShow);
        dispatch(commonSliceActions.setLoader(false));
      } else {
        setAssignedClassTrainersNames(null);
        setOverAllStatus(data.data);
      }
      setAcademicTermNotConfig(false);
    } else {
      setAcademicTermNotConfig(true);
      dispatch(commonSliceActions.setLoader(false));
    }
  };

  const setOverAllStatus = (classArray) => {
    let newArr = classArray.map((val, index) => {
      let completeCount = 0;
      let assignedCount = 0;
      let foundClassObj = find(allClasses, { id: val.classId });

      if (foundClassObj) {
        let currentModuleSessions = [];
        for (let monthData1 of val.monthWiseData) {
          if (monthData1.assignedSessionArr) {
            let temp = monthData1.assignedSessionArr.map((session) => {
              return session.name;
            });
            currentModuleSessions = currentModuleSessions.concat(temp);
          }
        }
        let completedSessionsTemp = [];
        for (let monthData of val.monthWiseData) {
          assignedCount += monthData.assignedSessionArr
            ? +monthData.assignedSessionArr.length
            : 0;
          if (monthData.teachData) {
            for (let innerVal of monthData.teachData) {
              console.log("innerVal.topicName", innerVal.topicName);
              let completeSec = innerVal.topicName.includes("Foundation")
                ? +process.env.REACT_APP_MIN_SEC_TO_COMPLETE_FOUNDATION
                : +process.env.REACT_APP_MIN_SEC_TO_COMPLETE;
              if (
                +innerVal.totalDuration / 1000 > +completeSec &&
                currentModuleSessions.indexOf(innerVal.topicName) > -1 &&
                completedSessionsTemp.indexOf(innerVal.topicName) == -1
              ) {
                completeCount += 1;
                completedSessionsTemp.push(innerVal.topicName);
              }
            }
          }
          if (
            getFormatedDate(new Date(), "MMM") == monthData.month &&
            getFormatedDate(new Date(), "YYYY") == monthData.year
          ) {
            break;
          }
        }
        let whereClassShouldBe =
          +currentModuleSessions.length > 0
            ? Math.round((+assignedCount / +currentModuleSessions.length) * 100)
            : 0;
        let whereClassIs =
          +currentModuleSessions.length > 0
            ? Math.round((+completeCount / +currentModuleSessions.length) * 100)
            : 0;
        console.log("index", index);
        console.log("completeCount", completeCount);
        console.log("assignedCount", assignedCount);
        console.log("currentModuleSessions", currentModuleSessions.length);
        console.log("whereClassShouldBe", whereClassShouldBe);
        console.log("whereClassIs", whereClassIs);

        return {
          classId: foundClassObj.id,
          className: foundClassObj.value,
          whereClassShouldBe: whereClassShouldBe,
          whereClassIs: whereClassIs,
          trainers: val.assignedClassTrainerName
            .map((tname) => {
              return joinByKeys(tname.name, ["firstname", "lastname"], " ");
            })
            .join(", "),
          currentModuleSessions: currentModuleSessions,
        };
      } else {
        return {
          classId: "Unknown",
          className: "Unknown Class",
          whereClassShouldBe: 0,
          whereClassIs: 0,
          trainers: val.assignedClassTrainerName
            .map((tname) => {
              return joinByKeys(tname.name, ["firstname", "lastname"], " ");
            })
            .join(","),
        };
      }
    });
    console.log("newArr", newArr);
    setAllClassStanding(newArr);
    dispatch(commonSliceActions.setLoader(false));
  };

  const getSessionName = (name) => {
    let splitedName = name.split("|");
    return splitedName[splitedName.length - 1].trim();
  };

  const completeOrNot = (duration, todo, did, date) => {
    let momentObj = moment(date);
    let currentMomentObj = moment();
    let durationSec = duration ? +duration / 1000 : 0;
    let completeSec = did.includes("Foundation")
      ? +process.env.REACT_APP_MIN_SEC_TO_COMPLETE_FOUNDATION
      : +process.env.REACT_APP_MIN_SEC_TO_COMPLETE;
    if (findIndex(todo, { name: did.trim() }) > -1) {
      if (durationSec == 0) {
        if (
          momentObj.month() <= currentMomentObj.month() &&
          momentObj.year() <= currentMomentObj.year()
        ) {
          return "IdealInComplete";
        } else {
          return "Future";
        }
      }
      if (durationSec > 0 && durationSec < completeSec) {
        return "IdealPartialComplete";
      }
      if (durationSec > completeSec) {
        return "IdealComplete";
      }
    } else {
      if (durationSec > 0 && durationSec < completeSec) {
        return "NotIdealPartialComplete";
      }
      if (durationSec > completeSec) {
        return "NotIdealComplete";
      }
    }
  };

  const combineData = (data1, data2) => {
    let newData = data2.map((val, index) => {
      return {
        topicName: val.name,
        totalDuration: 0,
      };
    });
    return unionBy(data1, newData, "topicName");
  };

  const colorSelect = (verb) => {
    if (verb == "IdealInComplete") {
      return {
        backgroundColor: "#f44336",
        color: "white",
      };
    }
    if (verb == "Future") {
      return {
        backgroundColor: "#9e9e9e",
        color: "white",
      };
    }
    if (verb == "IdealPartialComplete") {
      return {
        backgroundColor: "#ffb300",
        color: "white",
      };
    }
    if (verb == "IdealComplete") {
      return {
        backgroundColor: "#4caf50",
        color: "white",
      };
    }
    if (verb == "NotIdealPartialComplete" || verb == "NotIdealComplete") {
      return {
        backgroundColor: "#4fc3f7",
        color: "white",
      };
    }
  };

  const iconSelect = (verb) => {
    if (verb == "IdealInComplete") {
      return <EventBusyIcon color="white"></EventBusyIcon>;
    }
    if (verb == "Future") {
      return <EventIcon color="#212121"></EventIcon>;
    }
    if (verb == "IdealPartialComplete" || verb == "NotIdealPartialComplete") {
      return <EventNoteIcon color="white"></EventNoteIcon>;
    }
    if (verb == "IdealComplete" || verb == "NotIdealComplete") {
      return <EventAvailableIcon color="white"></EventAvailableIcon>;
    }
  };

  const checkAssignedClass = (arr) => {
    let foundObj = find(arr, { id: selectedClassId });
    if (foundObj) {
      return foundObj["totalWorkingDays"];
    } else {
      return 0;
    }
  };

  return (
    <>
      <Grid item xs={12} sx={{ px: 1 }}>
        <Grid
          container
          sx={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {userInfo.rolesInfo.title.toLowerCase() != "learner" && (
            <>
              <Grid item sx={{ px: 1 }}>
                <FormControl sx={{ minWidth: 150 }} size="small">
                  <ListItemText
                    primary={
                      <Typography
                        sx={{
                          px: 1,
                          fontSize: "0.8rem",
                          fontWeight: "500",
                          color: "#DB8829",
                          "@media (min-width: 1636px)": { fontSize: "1.4rem" },
                        }}
                      >
                        Select Classes
                      </Typography>
                    }
                  />
                  <Select
                    value={selectedClassId}
                    sx={{
                      borderRadius: 20,
                      borderColor: "#DB8829",
                      color: "#DB8829",
                      fontWeight: "500",
                      "@media (min-width: 1636px)": {
                        fontSize: "1.4rem",
                        width: "20ch",
                        mt: 0.5,
                      },
                    }}
                  >
                    {allClasses.map((itemData, index) => {
                      return (
                        <MenuItem
                          sx={{
                            color: "#DB8829",
                            fontSize: "0.8rem",
                            fontWeight: "500",
                            "@media (min-width: 1636px)": {
                              fontSize: "1.2rem",
                            },
                          }}
                          key={`${index}_Class`}
                          value={itemData.id}
                          onClick={() => {
                            handleClassChange(itemData);
                          }}
                        >
                          {itemData.value}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
                {assignedClassTrainersNames && (
                  <Typography
                    variant="h6"
                    color={"primary.main"}
                    fontSize={"0.9rem"}
                    mt={3}
                    maxWidth={"10rem"}
                  >
                    Trainers : {assignedClassTrainersNames}
                  </Typography>
                )}
              </Grid>
            </>
          )}
          {selectedClassId !== "all" && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "60vw",
              }}
            >
              <Box sx={{ minWidth: 35, alignSelf: "flex-start" }}>
                <Typography
                  variant="h6"
                  color={"primary.main"}
                >{`Course Completed: ${
                  completion ? Math.round(+completion.toFixed(2)) : 0
                }%`}</Typography>
              </Box>
              <Box sx={{ width: "100%", mr: 1 }}>
                <LinearProgress
                  variant="determinate"
                  value={completion}
                  sx={{ height: "2vh", borderRadius: 50 }}
                />
              </Box>
              <Box
                sx={{
                  width: "100%",
                  mr: 1,
                  mt: 1,
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-around",
                  borderBottom: "1px solid #ccc",
                }}
              >
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                  <CircleIcon sx={{ color: "#f44336" }}></CircleIcon>
                  <Typography ml={1}>Pending</Typography>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "row" }} ml={2}>
                  <CircleIcon sx={{ color: "#ffb300" }}></CircleIcon>
                  <Typography ml={1}>Partially Completed</Typography>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                  <CircleIcon sx={{ color: "#4caf50" }}></CircleIcon>
                  <Typography ml={1}>Completed as per schedule</Typography>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                  <CircleIcon sx={{ color: "#4fc3f7" }}></CircleIcon>
                  <Typography ml={1}>Off-Schedule Delivery</Typography>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                  <CircleIcon sx={{ color: "#9e9e9e" }}></CircleIcon>
                  <Typography ml={1}>Upcoming</Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  width: "100%",
                  mr: 1,
                  mt: 1,
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-around",
                  borderBottom: "1px solid #ccc",
                }}
              >
                <Box sx={{ display: "flex", flexDirection: "row", ml: 3 }}>
                  <EventAvailableIcon
                    sx={{ color: "#DB8829" }}
                  ></EventAvailableIcon>
                  <Typography ml={1}>Completed Session</Typography>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "row", ml: 3 }}>
                  <EventNoteIcon sx={{ color: "#DB8829" }}></EventNoteIcon>
                  <Typography ml={1}>Partially Completed Session</Typography>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                  <EventBusyIcon sx={{ color: "#DB8829" }}></EventBusyIcon>
                  <Typography ml={1}>Not Delivered</Typography>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "row", ml: 3 }}>
                  <EventIcon sx={{ color: "#DB8829" }}></EventIcon>
                  <Typography ml={1}>Upcoming Session</Typography>
                </Box>
              </Box>
            </Box>
          )}
          {selectedClassId == "all" && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "60vw",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  mr: 1,
                  mt: 1,
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                }}
              >
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                  <CircleIcon sx={{ color: "#DB8829" }}></CircleIcon>
                  <Typography ml={1}>On-Schedule</Typography>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "row" }} ml={2}>
                  <CircleIcon sx={{ color: red[800] }}></CircleIcon>
                  <Typography ml={1}>Delayed</Typography>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "row" }} ml={2}>
                  <CircleIcon sx={{ color: "#86CC7D" }}></CircleIcon>
                  <Typography ml={1}>Ahead-of-Schedule</Typography>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "row" }} ml={20}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={defaulterFlag}
                        onInput={() => {
                          setDefaulterFlag((prevState) => {
                            return !prevState;
                          });
                        }}
                      />
                    }
                    label="Non-compliant Only"
                  />
                </Box>
              </Box>
            </Box>
          )}
        </Grid>
        {selectedClassId &&
          selectedClassId != "all" &&
          classesWithData.indexOf(selectedClassId) > -1 && (
            <Grid   sx={{ mt: 2 }}>
              <Timeline
                sx={{
                  [`& .${timelineOppositeContentClasses.root}`]: {
                    flex: 0.2,
                  },
                }}
              >
                {classwiseData.map((classData, index) => {
                  return (
                    <TimelineItem>
                      <TimelineOppositeContent sx={{ py: "12px", px: 2 }}>
                        <Typography
                          variant="h6"
                          component="span"
                          color={"primary.main"}
                        >
                          {classData.month}-{classData.year}
                        </Typography>
                        <br></br>
                        <Typography color={"primary.main"} variant="caption">
                          {checkAssignedClass(
                            classData.actualWorkingDayAfterLeaves
                          )}{" "}
                          Working{" "}
                          {`${
                            checkAssignedClass(
                              classData.actualWorkingDayAfterLeaves
                            ) == 1
                              ? "day"
                              : "days"
                          }`}
                        </Typography>
                      </TimelineOppositeContent>
                      <TimelineSeparator>
                        <TimelineConnector sx={{ bgcolor: "primary.main" }} />
                        <TimelineDot color="primary">
                          <SourceIcon />
                        </TimelineDot>
                        <TimelineConnector sx={{ bgcolor: "primary.main" }} />
                      </TimelineSeparator>
                      <TimelineContent sx={{ py: "12px", px: 2 }}>
                        {classData.teachData.length > 0 &&
                          classData.teachData.map((val1, index1) => {
                            return (
                              <Tooltip
                                title={
                                  val1.topicLastDate
                                    ? `Last visit : ${getFormatedDate(
                                        val1.topicLastDate,
                                        "DD-MMM-YYYY"
                                      )}`
                                    : ""
                                }
                                placement="top"
                                arrow
                              >
                                <Chip
                                  label={getSessionName(val1.topicName)}
                                  icon={iconSelect(val1.status)}
                                  //color={colorSelect(val1.status)}
                                  sx={{
                                    m: 0.5,
                                    fontSize: "0.9em",
                                    fontWeight: "bold",
                                    ...colorSelect(val1.status),
                                  }}
                                />
                              </Tooltip>
                            );
                          })}
                        {classData.teachData.length == 0 && (
                          <Chip
                            label={
                              completeHere <= index && completeHere != -1
                                ? `All sessions covered`
                                : `Not enough days to complete a session`
                            }
                            icon={
                              completeHere <= index && completeHere != -1 ? (
                                <DescriptionIcon></DescriptionIcon>
                              ) : (
                                <ErrorOutlineIcon></ErrorOutlineIcon>
                              )
                            }
                            sx={{
                              m: 0.5,
                              fontSize: "0.9em",
                              fontWeight: "bold",
                              backgroundColor: "#FFF",
                              border: "1px solid #666",
                              color: "#666",
                            }}
                          />
                        )}
                      </TimelineContent>
                    </TimelineItem>
                  );
                })}
              </Timeline>
            </Grid>
          )}
        {selectedClassId &&
          selectedClassId != "all" &&
          !academicTermNotConfig &&
          classesWithData.indexOf(selectedClassId) == -1 && (
            <Grid
               
              container
              sx={{ mt: 2, justifyContent: "center" }}
            >
              <Typography fontSize={22} color={"#999"} marginTop={20}>
                Course not yet assigned to this class
              </Typography>
            </Grid>
          )}
        {academicTermNotConfig && (
          <Grid
             
            container
            sx={{ mt: 2, justifyContent: "center" }}
          >
            <Typography fontSize={22} color={"#999"} marginTop={20}>
              Academic course config is pending. Please contact admin.
            </Typography>
          </Grid>
        )}
        {selectedClassId == "all" && (
          <Box
             
            sx={{
              mt: 2,
            }}
          >
            {allClassStanding
              .filter((o) => {
                return (
                  (defaulterFlag && +o.whereClassIs < +o.whereClassShouldBe) ||
                  !defaulterFlag
                );
              })
              .map((sval, sindex) => {
                return (
                  <Grid
                    container
                    sx={{
                      mx: 2,
                      py: 2,
                      borderBottom: "1px solid #ddd",
                      maxWidth: "75vw",
                    }}
                  >
                    <Grid
                      item
                      xs={2}
                      sx={{ textAlign: "center", alignContent: "center" }}
                    >
                      {/* <Typography
                        fontWeight={500}
                        fontSize={22}
                        color={"primary"}
                        mt={1}
                      >
                        {sval.className}
                      </Typography> */}
                      <Button
                        variant="text"
                        color={"primary"}
                        sx={{ fontSize: 22 }}
                        onClick={() => {
                          handleClassChange({
                            id: sval.classId,
                            value: sval.className,
                          });
                        }}
                      >
                        {sval.className}
                      </Button>
                    </Grid>
                    <Grid item xs={9} sx={{ flexDirection: "column" }}>
                      {sval.trainers && sval.trainers.length > 0 && (
                        <Typography
                          sx={{ fontSize: "0.9rem" }}
                          color={"primary"}
                        >
                          Trainers : {sval.trainers}
                        </Typography>
                      )}
                      <Grid container>
                        <Grid item xs={11}>
                          <LinearProgress
                            variant="determinate"
                            value={sval.whereClassShouldBe}
                            sx={{ height: "1.5vh", borderRadius: 50, mt: 1 }}
                          />
                        </Grid>
                        <Grid item xs={1}>
                          <Typography px={1}>
                            {sval.whereClassShouldBe}%
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid container>
                        <Grid item xs={11}>
                          <LinearProgress
                            variant="determinate"
                            color={
                              +sval.whereClassShouldBe < +sval.whereClassIs
                                ? "success"
                                : "secondary"
                            }
                            value={sval.whereClassIs}
                            sx={{ height: "1.5vh", borderRadius: 50, mt: 1 }}
                          />
                        </Grid>
                        <Grid item xs={1}>
                          <Typography px={1}>{sval.whereClassIs}%</Typography>
                        </Grid>
                      </Grid>
                      {!sval.currentModuleSessions ||
                        (sval.currentModuleSessions &&
                          sval.currentModuleSessions.length == 0 && (
                            <Typography
                              sx={{ color: "#888" }}
                              variant="caption"
                            >
                              Course not assigned
                            </Typography>
                          ))}
                    </Grid>
                  </Grid>
                );
              })}
          </Box>
        )}
      </Grid>
    </>
  );
};

const useStyles = makeStyles({
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.6em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
    height: "70vh",
    overflow: "auto",
  },
});
export default ClasswiseUsage;
